// extracted by mini-css-extract-plugin
export var content = "form-select-module--content--0888f";
export var item = "form-select-module--item--c0efb";
export var trigger = "form-select-module--trigger--92fbb";